import script from "./ScheduledProjectsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScheduledProjectsPage.vue?vue&type=script&setup=true&lang=ts"

import "./ScheduledProjectsPage.vue?vue&type=style&index=0&id=7c0ccd46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c0ccd46"]])

export default __exports__